import { Link } from 'react-router-dom'
import ContentSection from '../components/ContentSection'
import { whyChooseContent } from '../data/gaiaCustomerStory'
import garyPhoto from '../assets/images/gary.png'
import elliotPhoto from '../assets/images/elliot.png'
import santokhPhoto from '../assets/images/santokh.png'

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary-green to-secondary-green py-20 md:py-32">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-poppins font-bold mb-6">
              About Gaia Powered
            </h1>
            <p className="text-xl md:text-2xl">
              Your trusted partner in sustainable energy solutions
            </p>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="py-16 md:py-24">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-poppins font-bold text-dark-plum mb-6">
              Our Story
            </h2>
            <p className="text-lg text-gray-700">
              Gaia Powered was born when two neighbours joined forces. Gary, who saw the flaws and frustrations homeowners faced in the domestic market, and Elliot, who brought the meticulous planning and high standards of the commercial sector. Together, we set out to raise the bar: delivering cost-effective, well-designed renewable systems for homeowners & businesses, built with the same care, detail, and reliability you'd expect from the biggest commercial projects.
            </p>
          </div>
        </div>
      </section>

      {/* Our Leadership Section */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container-custom">
          <h2 className="text-3xl md:text-4xl font-poppins font-bold text-dark-plum mb-12 text-center">
            Our Leadership
          </h2>
          <div className="max-w-5xl mx-auto space-y-16">
            {/* Elliot */}
            <div className="flex flex-col md:flex-row-reverse items-center gap-8">
              <div className="w-48 h-48 rounded-full overflow-hidden flex-shrink-0 shadow-lg">
                <img
                  src={elliotPhoto}
                  alt="Elliot"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="text-2xl font-poppins font-semibold text-dark-plum mb-2 text-center md:text-left">
                  Elliot
                </h3>
                <p className="text-sm text-primary-green font-semibold mb-4 text-center md:text-left">
                  Co-Founder | Project Delivery & Commercial Lead
                </p>
                <p className="text-lg text-gray-700">
                  Elliot brings a strong commercial M&E background, having delivered complex building services projects as a Project Manager across demanding environments.
                  His experience spans programme control, cost management, and coordination of multiple trades, ensuring systems are delivered accurately and efficiently on site.
                  At Gaia Powered, Elliot leads on project delivery and operational oversight. He ensures that designs translate into well-executed installations, with clear sequencing, realistic programmes, and tight quality control.
                  Elliot’s strength lies in bridging design and construction. He understands what it takes to deliver high-performance energy systems within real-world site constraints, budgets, and timelines.
                </p>
              </div>
            </div>

            {/* Gary */}
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="w-48 h-48 rounded-full overflow-hidden flex-shrink-0 shadow-lg">
                <img
                  src={garyPhoto}
                  alt="Gary"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="text-2xl font-poppins font-semibold text-dark-plum mb-2 text-center md:text-left">
                  Gary
                </h3>
                <p className="text-sm text-primary-green font-semibold mb-4 text-center md:text-left">
                  Co-Founder | Technical & Design Lead
                </p>
                <p className="text-lg text-gray-700">
                  Gary began his career as a hands-on heating engineer, building deep technical expertise across domestic heating systems before progressing into management roles and senior sales positions.
                  In 2020, Gary moved fully into heat pump systems, working at the early edge of the UK’s transition away from gas. This experience gives him a rare combination of site-level understanding, commercial awareness, and practical design insight.
                  Today, Gary works closely with architects and builders at early design stage. He focuses on system feasibility, coordination, and future-proofing, helping teams avoid rework and deliver heating systems that perform as designed.
                  Gary is known for clear communication, technical accuracy, and a collaborative approach that supports design intent while ensuring buildability.
                </p>
              </div>
            </div>

          <div className="max-w-5xl mx-auto space-y-16">
            {/* Santokh */}
            <div className="flex flex-col md:flex-row-reverse items-center gap-8">
              <div className="w-48 h-48 rounded-full overflow-hidden flex-shrink-0 shadow-lg">
                <img
                  src={santokhPhoto}
                  alt="Santokh"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="text-2xl font-poppins font-semibold text-dark-plum mb-2 text-center md:text-left">
                  Santokh
                </h3>
                <p className="text-sm text-primary-green font-semibold mb-4 text-center md:text-left">
                  Operations & Compliance Lead
                </p>
                <p className="text-lg text-gray-700">
                  Santokh brings a strong background in planning and coordination, with a detailed understanding of compliance processes within the renewable energy sector.
                  At Gaia Powered, Santokh leads operational planning and compliance management. He oversees critical processes including MCS compliance, DNO applications, and grant administration, ensuring projects progress smoothly and meet all regulatory requirements.
                  His role ensures that technical designs and site delivery are supported by accurate documentation, correct sequencing, and clear approvals.
                  Santokh provides the compliance and operational structure that underpins every Gaia project, supporting architects and builders with a reliable, well-governed installation journey.
                </p>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>

      {/* Values Section - GAIA Acronym */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="container-custom">
          <h2 className="text-3xl md:text-4xl font-poppins font-bold text-dark-plum mb-4 text-center">
            Our Values
          </h2>
          <p className="text-lg text-gray-600 text-center mb-12 max-w-2xl mx-auto">
            The principles that guide everything we do at Gaia Powered
          </p>
          <div className="max-w-4xl mx-auto space-y-6">
            {/* G - Growth */}
            <div className="group flex items-stretch bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden">
              <div className="w-24 md:w-32 flex-shrink-0 bg-gradient-to-br from-primary-green to-secondary-green flex items-center justify-center">
                <span className="text-5xl md:text-6xl font-poppins font-bold text-white">G</span>
              </div>
              <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                <h3 className="text-xl md:text-2xl font-poppins font-bold text-dark-plum mb-2">
                  Growth
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  We grow people, capability and impact, driving the renewable industry forward.
                </p>
              </div>
            </div>

            {/* A - Ambition */}
            <div className="group flex items-stretch bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden">
              <div className="w-24 md:w-32 flex-shrink-0 bg-gradient-to-br from-primary-green to-secondary-green flex items-center justify-center">
                <span className="text-5xl md:text-6xl font-poppins font-bold text-white">A</span>
              </div>
              <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                <h3 className="text-xl md:text-2xl font-poppins font-bold text-dark-plum mb-2">
                  Ambition
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  We set bold standards, challenge the industry, and constantly aim higher.
                </p>
              </div>
            </div>

            {/* I - Integrity */}
            <div className="group flex items-stretch bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden">
              <div className="w-24 md:w-32 flex-shrink-0 bg-gradient-to-br from-primary-green to-secondary-green flex items-center justify-center">
                <span className="text-5xl md:text-6xl font-poppins font-bold text-white">I</span>
              </div>
              <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                <h3 className="text-xl md:text-2xl font-poppins font-bold text-dark-plum mb-2">
                  Integrity
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  We act with honesty, responsibility and transparency in everything we do.
                </p>
              </div>
            </div>

            {/* A - Accuracy */}
            <div className="group flex items-stretch bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden">
              <div className="w-24 md:w-32 flex-shrink-0 bg-gradient-to-br from-primary-green to-secondary-green flex items-center justify-center">
                <span className="text-5xl md:text-6xl font-poppins font-bold text-white">A</span>
              </div>
              <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                <h3 className="text-xl md:text-2xl font-poppins font-bold text-dark-plum mb-2">
                  Accuracy
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  We deliver precise, detail-driven work that ensures flawless results.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>


      <ContentSection
        {...whyChooseContent}
        backgroundColor="white"
        textAlign="center"
        itemStyle="bento"
      />

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-gradient-to-br from-primary-green to-secondary-green">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-poppins font-bold mb-6">
            Ready to Make the Switch?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join thousands of UK homeowners who have reduced their carbon footprint
            and energy bills with Gaia Powered.
          </p>
          <Link
            to="/quote"
            className="inline-block bg-white text-primary-green px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Get Your Free Quote
          </Link>
        </div>
      </section>
    </div>
  )
}

export default AboutUs
